import styled, { css, keyframes } from 'styled-components'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

export const StyledAnimationProvider = {
  Wrapper: styled.div<{ $isAnimated: boolean }>`
    height: 100%;

    ${({ $isAnimated }) =>
      $isAnimated &&
      css`
        animation: ${fadeIn} 150ms ease-out;
      `}
  `,
}
